/* eslint-disable max-len */
import login1 from '../../../../shared/img/ppt/login1.png';

const addSlide6 = (pptx, addBrandingToSlide) => {
  // presentation slide
  const slide6 = pptx.addSlide({ masterName: 'COMPANY_BRANDING' });
  slide6.addText('SE CONNECTER', {
    x: 1.25,
    y: 0.25,
    w: 8,
    h: 0.5,
    align: 'center',

    // Style du texte
    fontSize: 22,
    color: '4f4f4f',
    bold: true,

    // Style de la forme
    shape: pptx.ShapeType.rect,
    fill: { color: 'fae3f2' },

    // Bordure
    line: {
      color: 'f71616',
      width: 1,
    },
  });

  slide6.addText('Rendez-vous sur le site: https://englishworld-learning.fr', {
    x: 1.25,
    y: 0.75,
    w: 7,
    h: 0.5,
    align: 'center',
    fontSize: 16,
    color: '696969',
  });

  slide6.addImage({
    path: login1,
    x: 0.2,
    y: 1.5,
    w: 4.5,
    h: 2.5,
  });

  slide6.addText([
    { text: '1. Indiquez l\'adresse e-mail et le mot de passe que vous avez choisi lors de la création de votre compte.\n', options: { color: '696969' } },
    { text: '2. Cliquez sur «Se connecter»', options: { color: '696969' } },
  ], {
    x: 5,
    y: 1.5,
    w: 4.8,
    h: 1.5,
    fontSize: 15,
    shape: pptx.ShapeType.rect,
    fill: { color: 'ffffff' },
    wrap: true,
    line: {
      color: 'FF0000',
      width: 1,
    },
  });
  slide6.addText([
    { text: 'Cliquez sur le bouton "Besoin d\'aide? Assistance" si ', options: { color: '696969' } },
    { text: 'vous rencontrez des difficultés', options: { bold: true, color: '696969' } },
    { text: ' pour accéder à la plateforme', options: { color: '696969' } },
  ], {
    x: 5,
    y: 3.1,
    w: 4.8,
    h: 1,
    fontSize: 15,
    shape: pptx.ShapeType.rect,
    fill: { color: 'ffffff' },
    wrap: true,
    line: {
      color: 'FF0000',
      width: 1,
    },
  });

  slide6.addText([
    { text: 'La déconnexion n\'est pas automatique à la fermeture du navigateur ou de l\'onglet. Il est important de ', options: { color: '696969' } },
    { text: 'se connecter au début de chaque session', options: { bold: true, color: '696969' } },
    { text: ', pour la mise à jour des versions de la plateforme. Si besoin, veuillez vous déconnecter et vous reconnecter.', options: { color: '696969' } },
  ], {
    x: 0.5,
    y: 4.1,
    w: 9,
    h: 1.5,
    fontSize: 15,
    wrap: true,
  });

  addBrandingToSlide(pptx, slide6);
};

export default addSlide6;
